<ag-job-list
  [requestObject]="requestObject"
  [options]="listConfiguration"
  (itemSelected)="jobSelected.emit($event)"
>
</ag-job-list>
